<template>
  <div class="backstage-index">
    <div class="head">
      <!-- 布局头部导航栏 -->
      <page-head @loginOut="loginOut"/>
    </div>
    <div class="layout">
      <!-- 布局侧边栏 -->
      <div class="aside">
        <!-- 布局导航栏 -->
        <div class="menu">
          <menu-Layout :menuList="menuList" :isLevelAdmin="isLevelAdmin" />
        </div>
      </div>
      <div class="right-layout">
        <!-- 面包屑 -->
        <div class="bread-crumb">
          <bread-crumb />
        </div>
        <!-- 顶部导航 -->
        <div class="top-menu" v-show="isShowTopMenu">
          <top-menu />
        </div>
        <!-- 内容区 -->
        <div id="content" class="content finance-content" :class="addClassNameStr">
          <div class="main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHead from "@/components/layout/page-head";
import BreadCrumb from "@/components/layout/bread-crumb";
import MenuLayout from "@/components/layout/Menu";
import TopMenu from "@/components/layout/top-menu";
import { config } from '@/common/js/config.js'
import { deleteToken, deleteAdminType, deleteUserName, deleteIsAdmin, deleteTeamId } from "@/common/js/storage";
export default {
  components: {
    PageHead,
    MenuLayout,
    BreadCrumb,
    TopMenu
  },

  data() {
    return {
      menuList: [
        {
          name: "报销模块",
          url: "/finance/reimbursementIndex",
          img: require('../../assets/menu/reimbursementModule.png'),
          children: [
            {
              name: "待审批列表",
              url: "/finance/reimbursementIndex/approvalIndex/approval",
              commonUrl: '/finance/reimbursementIndex/approvalIndex',
            },
            {
              name: "已审批列表",
              url: "/finance/reimbursementIndex/finishApprovalIndex/finishApproval",
              commonUrl: '/finance/reimbursementIndex/finishApprovalIndex',
            },
          ]
        },
      ],
      isShowTopMenu: false,
      isLevelAdmin: 4,
      addClassNameStr: 'approval-scroll'
    };
  },

  watch: {
    $route(to, form) {
      if (to.path === '/finance/reimbursementIndex/approvalIndex/approval') {
        this.addClassNameStr = 'approval-scroll'
      } else {
        this.addClassNameStr = 'finish-approval-scroll'
      }
    }
  },

  created() {
    config()
  },
  mounted() {
    if (this.$route.path === '/finance/reimbursementIndex/approvalIndex/approval') {
      this.addClassNameStr = 'approval-scroll'
    } else {
      this.addClassNameStr = 'finish-approval-scroll'
    }
    this.$bus.on("isShowTopMenu", v =>{
      this.isShowTopMenu = v
    });
  },

  methods: {
    loginOut() {
      //后财增加退出埋点 20250805
      sensors_sw.logout();
      deleteToken()
      deleteAdminType()
      deleteUserName()
      deleteIsAdmin()
      deleteTeamId()
      this.$router.push('/')
    }
  },
};
</script>

<style lang='scss' scoped>
.backstage-index .layout .right-layout .finance-content {
  padding: 0px;
}
</style>
